var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"height":"600px"}},_vm._l((_vm.img),function(item){return _c('el-carousel-item',{key:item},[_c('img',{attrs:{"src":item,"alt":""}})])}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }